module.exports = "/matchcenter-staging/assets/images/mega.b725d4886901029e271aeff70cdd2d72.png";